<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('setting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('setting.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <h4 class="ts-bg-gray-300 ts-px-2 ts-py-1">
            {{ $t('setting.systemSetting') }}
          </h4>
          <div class="ts-p-2">
            <form class="form-horizontal ts-space-y-2">
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Stock alert vai web</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.stock_alert_via_web"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Stock alert via mobile</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.stock_alert_via_mobile"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >FIFO stock deduction</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.is_fifo_stock_deduction"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Allow sale without stock</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.is_allow_sale_without_stock"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Close shift require password</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.is_close_shift_require_pwd"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Cost of goods sold method</label
                >
                <div class="col-md-8">
                  <select
                    v-model.number="model.cogs_method_id"
                    class="ts-border ts-text-right ts-rounded-md ts-py-1 ts-w-40 ts-outline-none"
                  >
                    <option
                      v-for="(m, index) in saleMethods"
                      :key="index"
                      :value="m.cogs_method_id"
                      >{{ m.cogs_method }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >VAT rate</label
                >
                <div class="col-md-8">
                  <input
                    v-model.number="model.vat_rate"
                    type="number"
                    class="ts-border ts-rounded-md ts-text-right ts-py-1 ts-w-40 ts-outline-none"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Mart Receipt</label
                >
                <div class="col-md-8">
                  <select
                    v-tooltip="'Wholesale Receipt'"
                    v-model="model.enable_mart_receipt"
                    class="ts-border ts-text-right ts-rounded-md ts-py-1 ts-w-40 ts-outline-none"
                  >
                    <option :value="true">Mart</option>
                    <option :value="false">Café</option>
                  </select>
                  <span class="ts-ml-3">(Waiting number)</span>
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Mart receipt paper size</label
                >
                <div class="col-md-8">
                  <select
                    v-tooltip="'Retail sale Receipt'"
                    v-model="model.retail_sale_receipt"
                    class="ts-border ts-text-right ts-rounded-md ts-py-1 ts-w-40 ts-outline-none"
                  >
                    <option value="RP">Receipt Printer</option>
                    <option value="A5">A5</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Auto print ORDER</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.is_print_order"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Auto print BILL</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.auto_print_bill"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Auto Print KOT</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.is_print_kot"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Auto print DO</label
                >
                <div class="col-md-8">
                  <a-switch
                    class="ts-mt-2"
                    size="small"
                    v-model="model.is_auto_print_delivery_order"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Wholesale receipt</label
                >
                <div class="col-md-8">
                  <select
                    v-tooltip="'Wholesale Receipt'"
                    v-model="model.whole_sale_receipt"
                    class="ts-border ts-text-right ts-rounded-md ts-py-1 ts-w-40 ts-outline-none"
                  >
                    <option value="A4">A4</option>
                    <option value="A5">A5</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Alert product expire X day</label
                >
                <div class="col-md-8">
                  <input
                    v-model.number="model.alert_expiry_in_xday"
                    type="number"
                    class="ts-border ts-rounded-md ts-text-right ts-py-1 ts-w-40 ts-outline-none"
                  />
                </div>
              </div>
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Distance allow check-in</label
                >
                <div class="col-md-8">
                  <input
                    v-model.number="model.distance_allow_check_in"
                    type="number"
                    class="ts-border ts-rounded-md ts-text-right ts-py-1 ts-w-40 ts-outline-none"
                  />
                  <span class="ts-ml-3">(meters)</span>
                </div>
              </div>
            </form>
          </div>
          <h4 class="ts-bg-gray-300 ts-px-2 ts-py-1 ts-mt-3">
            {{ $t('setting.adminSetting') }}
          </h4>
          <div class="ts-p-2">
            <form class="form-horizontal ts-space-y-2">
              <div class="row">
                <label
                  class="form-col-label control-label col-md-4 ts-text-base ts-font-normal"
                  >Idle Timeout</label
                >
                <div class="col-md-8">
                  <input
                    v-model.number="model.idle_time_out"
                    type="number"
                    class="ts-border ts-rounded-md ts-text-right ts-py-1 ts-w-40 ts-outline-none"
                  />
                  <span class="ts-ml-3">(1 - 408 minute)</span>
                </div>
              </div>
            </form>
          </div>
          <div class="ts-space-y-3">
            <div class="ts-flex ts-justify-end">
              <ts-button
                color="primary"
                :waiting="waiting"
                @click.prevent="onStore"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'setting',
  data () {
    return {
      loading: false,
      waiting: false,
      saleMethods: [],
      model: {
        stock_alert_via_web: true,
        stock_alert_via_mobile: true,
        is_fifo_stock_deduction: true,
        is_allow_sale_without_stock: true,
        is_close_shift_require_pwd: true,
        is_print_kot: true,
        enable_mart_receipt: true,
        is_print_order: true,
        auto_print_bill: true,
        cogs_method_id: 1,
        vat_rate: 10,
        idle_time_out: 2,
        whole_sale_receipt: 'A4',
        retail_sale_receipt: 'RP',
        is_auto_print_delivery_order: false,
        alert_expiry_in_xday: 7,
        distance_allow_check_in: 100
      }
    }
  },
  methods: {
    ...mapActions('setting/sysSetting', ['store', 'fetch', 'getCogs']),
    async fetchData () {
      this.loading = true
      await this.getCogs().then(response => {
        this.saleMethods = response.data
      })
      await this.fetch()
        .then(response => {
          this.setData(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onStore () {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setData (data) {
      if (data) {
        this.model.stock_alert_via_web = data.stock_alert_via_web
        this.model.stock_alert_via_mobile = data.stock_alert_via_mobile
        this.model.is_fifo_stock_deduction = data.is_fifo_stock_deduction
        this.model.is_allow_sale_without_stock =
          data.is_allow_sale_without_stock
        this.model.is_close_shift_require_pwd = data.is_close_shift_require_pwd
        this.model.enable_mart_receipt = data.enable_mart_receipt
        this.model.is_print_kot = data.is_print_kot
        this.model.is_print_order = data.is_print_order
        this.model.auto_print_bill = data.auto_print_bill
        this.model.cogs_method_id = data.cogs_method_id
        this.model.vat_rate = data.vat_rate
        this.model.idle_time_out = data.idle_time_out ? data.idle_time_out : 2
        this.model.whole_sale_receipt = data.whole_sale_receipt
        this.model.retail_sale_receipt = data.retail_sale_receipt
        this.model.is_auto_print_delivery_order =
          data.is_auto_print_delivery_order
        this.model.alert_expiry_in_xday = data.alert_expiry_in_xday
        this.model.distance_allow_check_in = data.distance_allow_check_in
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
